import React from "react";
import ContactCard from "../../Templates/ContactCard/ContactCard";
import Navigation from "../../Templates/Navigation/Navigation";
import TopRow from "../../Templates/Navigation/TopRow";

const ContactScreen = () => {
	return (
		<>
			<Navigation />
			<ContactCard />
		</>
	);
};

export default ContactScreen;
